import { Route, Routes } from 'react-router-dom'
import SubstitutePortalPage from './Page'

export default function SubstituteIndex() {
  return (
    <Routes>
        <Route path="/" element={<SubstitutePortalPage />} />
        <Route path="/:id" element={<SubstitutePortalPage />} />
    </Routes>
  )
}  